import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {Scrollbars} from 'react-custom-scrollbars';
import stringformat from 'stringformat';
import Checkbox from 'toluna-react-components/Inputs/Checkbox';
import styles from './styles.scss';

const CheckboxesPanel = ({
	options,
	isSelectAll,
	selectAllText,
	totalFilterItemCount,
	clearStr,
	filterSelectionCountStr,
	filterAllSelectionCountStr,
	selectAllCountStr,
	noOptionsStr,
	onItemValueChange,
	onToggleSelectAll,
	onToggleAllVisibleValues
}) => {

  //console.log(clearStr, totalFilterItemCount, filterSelectionCountStr, filterAllSelectionCountStr, selectAllCountStr);

  const selectedItemsCount = options.filter(option => option.selected === true).length;

  //console.log(selectedItemsCount, options.length, 'partial: ', selectedItemsCount > 0 && selectedItemsCount < options.length);

  return (
	  <div styleName="checkboxes-panel-wrapper">
		<div styleName="choice-item-select-all" className="choice-item">
		  <Checkbox
		      disabled={options.length ===0}
			  value={selectedItemsCount === options.length}
			  checked={selectedItemsCount > 0 && selectedItemsCount <= options.length}
			  partial={selectedItemsCount > 0 && selectedItemsCount < options.length}
			  onChange={onToggleAllVisibleValues}
		      small={true}
			  label={selectAllText}/>
		</div>
		{
		  getHelperSelectionBlock({
			options,
			selectedItemsCount,
			totalFilterItemCount,
			filterSelectionCountStr,
			selectAllCountStr,
			filterAllSelectionCountStr,
			clearStr,
			noOptionsStr,
			onToggleSelectAll,
			isSelectAll
		  })
		}
		<Scrollbars autoHeight>
		  <div styleName="choices-wrapper" className="choices-wrapper">
			{buildOptionsList({options, onItemValueChange})}
		  </div>
		</Scrollbars>
	  </div>
  );
};

CheckboxesPanel.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  isSelectAll: PropTypes.bool.isRequired,
  selectAllText: PropTypes.string.isRequired,
  totalFilterItemCount: PropTypes.number.isRequired,
  clearStr: PropTypes.string.isRequired,
  filterSelectionCountStr: PropTypes.string.isRequired,
  filterAllSelectionCountStr: PropTypes.string.isRequired,
  selectAllCountStr: PropTypes.string.isRequired,
  onItemValueChange: PropTypes.func.isRequired,
  onToggleSelectAll: PropTypes.func.isRequired,
  onToggleAllVisibleValues: PropTypes.func.isRequired
};

CheckboxesPanel.defaultProps = {
  options: [],
  isSelectAll: false,
  totalFilterItemCount: 0,
  clearStr: '',
  filterSelectionCountStr: '',
  filterAllSelectionCountStr: '',
  selectAllCountStr: '',
  onItemValueChange: () => {
  },
  onToggleSelectAll: () => {
  },
  onToggleAllVisibleValues: () => {
  }
};


export default CSSModules(CheckboxesPanel, {...styles}, {allowMultiple: true});

const buildOptionsList = ({options, onItemValueChange} = {}) => {
  return options.map((option, idx) => {
	return (
		<div styleName="choice-item" className="choice-item" key={idx}>
		  <Checkbox
			  value={option.selected === true}
			  checked={option.selected === true}
			  onChange={(value) => onItemValueChange(option)}
		      small={true}
			  label={option.name}/>
		</div>
	);
  });
};

const getHelperSelectionBlock = ({options, selectedItemsCount, totalFilterItemCount, filterSelectionCountStr, filterAllSelectionCountStr, selectAllCountStr, clearStr, noOptionsStr, onToggleSelectAll, isSelectAll}) => {
  const selectedStringFormatted = stringformat(filterSelectionCountStr.replace('%s', '{0}'), selectedItemsCount);
  const selectAllStringFormatted = stringformat(selectAllCountStr.replace('%s', '{0}'), totalFilterItemCount);
  const allSelectedStringFormatted = stringformat(filterAllSelectionCountStr.replace('%s', '{0}'), totalFilterItemCount);

  let leftBlockText = isSelectAll || (totalFilterItemCount === selectedItemsCount) ? allSelectedStringFormatted : selectedStringFormatted,
	  rightBlockText = isSelectAll || (totalFilterItemCount === selectedItemsCount) ? clearStr : selectAllStringFormatted;

  //console.log(isSelectAll);
  
  if(options.length === 0) {
	  return (
			  <div styleName="helper-no-selection-block">{noOptionsStr}</div>
	  );
  } else {

	  return (
		  <div styleName="helper-selection-block">
			{
			  [<div styleName="inner-block left-block" key={1}>
				<span>{leftBlockText}</span>
			  </div>,
				<div styleName="inner-block right-block" key={2}>
				  <span onClick={onToggleSelectAll}>{rightBlockText}</span>
				</div>]
			}
		  </div>
	  );
  }
};


// WEBPACK FOOTER //
// ./components/qual/Table/TableHeader/TableHeaderCell/TableColumnFilter/FilterTypes/MultipleChoice/CheckboxesPanel/CheckboxesPanel_component.js